import React, { useState } from 'react';



/**
 * @param {Object} obj 
 * @param {Array<string>} obj.images
 */
const Carousel = ({images}) => {
  const [current, setCurrent] = useState(0);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };
  
  const nextSlide = () => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="relative w-full max-w-2xl mx-auto h-64 md:h-96 flex items-center justify-center">
      <button
        onClick={prevSlide}
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-blue-900 bg-opacity-70 rounded-full p-2 text-white hover:bg-blue-700 z-10"
        aria-label="Anterior"
      >
        &#8592;
      </button>
      <img
        src={images[current]}
        alt={`Foto ${current + 1}`}
        className="rounded-xl shadow-lg w-full h-64 md:h-96 object-cover transition-all duration-500"
      />
      <button
        onClick={nextSlide}
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-blue-900 bg-opacity-70 rounded-full p-2 text-white hover:bg-blue-700 z-10"
        aria-label="Próxima"
      >
        &#8594;
      </button>
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {images.map((_, idx) => (
          <span
            key={idx}
            className={`w-3 h-3 rounded-full ${idx === current ? 'bg-blue-400' : 'bg-blue-200 opacity-50'} inline-block`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
